"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'System',
  data: function data() {
    return {
      loading: false,
      systemId: '',
      routes: [],
      currentSystem: {}
    };
  },
  computed: {
    list: function list() {
      return this.$store.getters.systemList;
    }
  },
  mounted: function mounted() {},
  methods: {
    handleCheckSystem: function handleCheckSystem(item) {
      this.systemId = item.appIdentification;
      this.currentSystem = item;
    },
    handleGetMenu: function handleGetMenu() {
      var _this = this;
      this.loading = true;
      this.$api.login.getUserInfo(this.systemId).then(function (res) {
        _this.$store.dispatch('user/setCurrentSystemInfo', _this.currentSystem);
        _this.$store.dispatch('nocache/setAddRoute', {
          isAddRoute: true
        });
        _this.$store.dispatch('permission/generateRoutes', res.data.menus).then(function (res) {
          // console.log('login----', res)
          _this.$router.push({
            path: '/dashboard'
          });
          _this.loading = false;
        });
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
};